import React from "react";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import useChangeCheck from "./useChangeCheck";
import ChangeCheckContext from "../support/ChangeCheckContext";

function IntegerInput(props) {
    const { onChange, getStyle } = useChangeCheck(props.onChange);
    const {disable} = React.useContext(ChangeCheckContext)

    function handleChange(event) {
        const selected = event.target.value
        if (selected === "") {
            onChange({target: {name: event.target.name, value: null}})
        } else {
            let number = parseInt(selected)
            onChange({target: {name: event.target.name, value: number}})
        }
    }

    return (
        <>
            {props.label ? <Form.Label htmlFor="basic-url">{props.label}</Form.Label> : null}
            <InputGroup className="mb-3">
                <Form.Control disabled={disable} type="number" name={props.name} onChange={handleChange} value={props.value} style={getStyle()}/>
            </InputGroup>
        </>
    )
}

export default IntegerInput
